module.exports = __webpack_public_path__ + "img/shenganlanlv.8d0782b5.png";